<template>

    <!-- 主容器 -->
    <div class="yx-div">
        <div style="position: absolute; margin-top: -10px; z-index: 99;">
            <span style="font-size: 13px; font-weight: bold; color: orange ">{{this.$router.currentRoute.name}}</span>
        </div>
    <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div  class="yx-flex-h-start2" style="margin-top: 5px;">
                    <div>
                        终端编号：
                        <el-input placeholder="终端编号" v-model="searchVal.terNo" clearable size="mini" style="width: 150px; margin-right: 15px;" />
                    </div>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-search" @click="searchDo">查询</el-button>
                </div>
            </div>
        </div>



        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="transs"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="mchName" label="商户名称"/>
                <el-table-column prop="mchNo" label="商户号" />
                <el-table-column prop="terNo" label="终端号"  />
                <el-table-column
                        align="center"
                        label="状态">
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.status===1" color="#FFFFFF">正常</el-tag>
                        <el-tag type="info" v-else color="#FFFFFF">停用</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="terName" label="终端名称" />
                <el-table-column prop="agentName" label="终端服务商" />
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-end">
            <el-pagination
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev,pager,next, jumper,->, total, slot"
                    :total="total">
            </el-pagination>
        </div>

    </div>

</template>

<script>
    // name 组件名
    // data return 组件内的变量声明
    // created:html加载完成前 执行。执行顺序:父组件-子组件
    // mounted:html加载完成后 执行。执行顺序:子组件-父组件
    // methods:事件方法
    // watch:去监听一个值的变化，然后执行相对应的函数
    // computed:computed是属性调用，而methods是函数调用，computed带有缓存功能，而methods不是
    export default {
        name: "BillMchInfo",
        //组件中的data和实例中的不一样，实例中的data是一个对象，而组件中的data则是一个方法并且返回一个对象
        data() {
            //所有的变量都是写在data 的return里面
            //使用return包裹后数据中变量只在当前组件中生效,不会影响其他组件。
            return {
                searchVal: {
                    terNo : null
                },
                loading: false, // 加载提示 v-loading 变量
                total: 0,       // 总计 变量
                page: 1,        // 页数 变量
                size: 10,       // 每页大小 变量

                acqChannels :[],   // 交易渠道 集合
                transs: [],   // 交易对象 数组变量
                oneTransDetail: null,
                transJnlKey: {
                    sysDate:'',
                    sysTime:'',
                    sysSerial:''
                }
            }
        },
        mounted() {
            this.initTransTotal();
        },
        methods: {
            searchReset() {
            },
            searchDo() {
                this.page = 1;
                this.initTransTotal();
            },
            initTransTotal() {
                this.loading = true;
                let url = '/bill/mchInfo/?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.terNo) {
                    url += '&terNo=' + this.searchVal.terNo;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.transs = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            exportData() {
                window.open('/bill/export', '_parent');
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTransTotal();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTransTotal();
            },
        }
    }
</script>

<style>

    .pageNormal {
        font-size: 13px;
        font-family: 微软雅黑;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }

    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .5s ease;
    }

    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .style-input-width {
        max-width: 120px;
    }

    .xtable{position:absolute;bottom:100px;}
    .xfooter{position:absolute;bottom:0;width:100%;height:100px;background-color: #ffc0cb;}

</style>
